<div *ngIf="show" class="modal-announcement-backdrop" (click)="onBackdrop($event)">
  <div class="modal-announcement" (click)="onModalClick($event)">
    <div class="modal-content">

      <div class="header">
        <h2>Release notes</h2>
        <button class="btn btn-close" (click)="onDismissClick()"></button>
      </div>
      <div class="notes major latest">
        <h3 class="date">Friday, January 30, 2026</h3>
        <ul>
          <li>
            <h4>Budget Page - Harvest Integration</h4>
            <ul>
              <li>Added <span class="hl">Budget (ClickUp)</span> column showing source of truth for project budgets</li>
              <li>Added <span class="hl">Sync</span> column with colored indicators (●) showing budget sync status between ClickUp and Harvest</li>
              <li>Added <span class="hl">Budget Spent</span> column showing real-time Harvest expenses (updates every 30 minutes)</li>
              <li>Added <span class="hl">Budget Remaining</span> column with hybrid calculation (ClickUp budget - Harvest expenses)</li>
              <li>Sync indicators are <span class="hl">clickable links</span> to Harvest project pages</li>
              <li>Fixed budget calculation formula: now uses Client Price instead of Client Price × Target Margin</li>
              <li>All new columns included in CSV and PDF exports</li>
            </ul>
          </li>
          <li>
            <h4>Projects & Budget Pages - Enhanced PO Filtering</h4>
            <ul>
              <li>Enabled <span class="hl">PO Number filter</span> on Projects page (previously disabled)</li>
              <li>Added <span class="hl">cascading filter logic</span> - PO dropdown now shows only POs from visible projects</li>
              <li>Fixed Budget page PO filter to filter both projects table AND POs table</li>
              <li>Added filter persistence across page reloads and sessions</li>
            </ul>
          </li>
          <li>
            <h4>Infrastructure</h4>
            <ul>
              <li>Set up <span class="hl">staging environment</span> at stage.ops.cnbl.io for testing before production</li>
              <li>Added environment-aware Firestore rules supporting prod, stage, and dev</li>
              <li>Created new Harvest data collection functions (runs every 6 hours)</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="notes major">
        <h3 class="date">Monday, November 3, 2025</h3>
        <ul>
          <li>
            <h4>Settings</h4>
            <ul>
              <li>Added <span class="hl">Settings Panel</span> accessible by clicking on username in header</li>
              <li>Added <span class="hl">year filter</span> to hide data from previous years.</li>
            </ul>
          </li>
        </ul>
        <ul>
          <li>
            <h4>General Fixes and Updates</h4>
            <ul>
              <li>Fixed <span class="hl">Job Code filter</span> filter on Projects page</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="notes major">
        <h3 class="date">Wednesday, July 30, 2025</h3>
        <ul>
          <li>
            <h4>Budget Checker</h4>
            <ul>
              <li>Fixed <span class="hl">Parent Job Code</span> filter</li>
              <li>Fixed <span class="hl">persistance of filter values</span> between sessions/page refresh.
              <li>Tweaked matching logic for <span class="hl">Client Lead</span> filter</li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="notes major">
        <h3 class="date">Tuesday, July 22, 2025</h3>
        <ul>
          <li>
            <h4>Projects Page</h4>
            <ul>
              <li>Added <span class="hl">Final Deliverables</span> in Links panel</li>
              <li>Tweaked link icons sizing and spacing.
              </li>
            </ul>
          </li>

        </ul>
      </div>
      <div class="notes major">
        <h3 class="date">Thursday, July 17, 2025</h3>
        <ul>
          <li>
            <h4>Global Updates</h4>
            <ul>
              <li>Bug fixes</li>
              <li>Replaced the old broken filters in the
                <pre class="inline">tools/expenses</pre> with our new shared filter bar.
              </li>
            </ul>
          </li>
          <li>
            <h4>Expenses Tool</h4>
            <ul>
              <li>Replaced the old broken filters with our new shared filter bar.
              </li>
            </ul>
          </li>

        </ul>
      </div>

      <div class="notes major">
        <h3 class="date">Wednesday, July 16, 2025</h3>
        <ul>
          <li>
            <h4>Global Updates</h4>
            <ul>
              <li> Added a <span class="hl">freeform text search</span> of all Projects, PO, and Budget Data</li>
              <li><span class="hl">Refactored the Filter Bar</span> into a shared component between pages, so it can be used, augmented, fixed, etc. centrally</li>

            </ul>
          </li>
          <li>
            <h4>Projects Page</h4>
            <ul>
              <li>Added a sortable <span class="hl">Client Lead column and filter</span> for Client Lead</li>

              <li>Fixed a bug that caused the accordion to get narrow when filtering</li>
            </ul>
          </li>
          <li>
            <h4>Budget Page</h4>
            <ul>
              <li><span class="hl">Squashed the 7px gap</span> between the Job Code and Project Name columns when filtering.</li>
            </ul>
          </li>

        </ul>
      </div>




      <div class="notes major">
        <h3 class="date">

          Friday, June 20, 2025
        </h3>
        <ul>
          <li>
            <h4>Global Updates</h4>
            <ul>
              <li>Cleaned up filter styles, <span class="highlight">removed filter pills</span></li>
            </ul>

          </li>
          <li>
            <h4>Budget Tool Updates</h4>
            <ul>
              <li>Removed the original Budget tool and renamed Burn to Budget</li>
              <li>Fixed Parent Job Code filter</li>
              <li>Moved Remaining column after Client Price</li>
              <li>Moved FY column after Project Name</li>
              <li>Froze first two columns: Job Code and Project Name</li>
            </ul>
          </li>

        </ul>
      </div>

      <div class="notes major">
        <h3 class="date">Monday, June 02, 2025</h3>
        <ul>
          <li>
            <h4>Global Updates</h4>
            <ul>
              <li>
                <h5>Added content types:</h5>
                <ul>
                  <li><strong>Sensitive:</strong> Contractor invoices, PII</li>
                  <li><strong>Development:</strong> Broken components, those still in development, extra visual markers</li>
                  <li><strong>Finance:</strong> Budgets, (aggregated, anonymized) Labor Expenses</li>
                  <li><strong>General:</strong> Progress and Status data for projects</li>
                  <li><strong>Individual:</strong> Data specifically tailored for and germane to specific Cannonballers</li>
                </ul>
              </li>
            </ul>
            <ul>
              <li>
                <h5>Added access roles:</h5>
                <ul>
                  <li><strong>Admin:</strong> Connor, Dixie, Andrew, Chris, Jaime</li>
                  <ul>
                    <li style="padding-top:0; font-weight:400">Sensitive, Finance, General (no Development).</li>
                  </ul>
                  <li><strong>Dev:</strong> Eric, Rebecca, Kiki</li>
                  <ul>
                    <li style="padding-top:0; font-weight:400">Development, Finance, General (no Sensitive).</li>
                  </ul>
                  <li><strong>Finance:</strong> Paul</li>
                  <ul>
                    <li style="padding-top:0; font-weight:400">All data types (no Development).</li>
                  </ul>
                  <li><strong>PM:</strong> Mikey, Sabrina, Maryann, Hunter</li>
                  <li><strong>EL:</strong> None</li>
                  <li><strong>IC:</strong> None</li>
                </ul>
              </li>
            </ul>


          <li>
            <h4>Projects Page</h4>
            <ul>
              <li>Refined the overall page design
              <li>Moved the filter bar to the bottom at all breakpoints</li>
              <li>Tidied up some column widths and data wrapping behavior</li>
              <li>Fixed the Projects accordion to scroll left/right on very narrow widths rather than bunching up</li>
            </ul>
          </li>
          <li>
            <h4>Bug Fixes</h4>
            <ul>
              <li>Refactored the full ClickUp collection script (the one that runs hourly and gets data from ClickUp)</li>
              <li>Fixed memory limit issue with clickupAll collection</li>


            </ul>
          </li>


          <li>
            <h4>Backend Functions</h4>
            <ul>
              <li>All ClickUp Data is backed up at 12:00am (PDT) then deleted and rewritten at 12:06am</li>
              <li>Fixed memory limit issue with clickupAll collection</li>


            </ul>
          </li>


          <ng-container *ngIf="auth.userRole$ | async as role">
            <li *ngIf="role === 'finance' || role === 'admin' || role === 'dev' || role === 'god'">
              <h4 class="highlight yellow">Dev Only*</h4>
              <ul>
                <li>
                  <h5>Tools menu</h5>
                  <ul>
                    <li><strong>Diagnostics:</strong> Checks PM/EL Workloads</li>
                    <li><strong>Expenses:</strong> Compares actual costs from quickbooks to progress/budget as reported by PMs</li>
                  </ul>
                </li>
                <li>
                  <h5>Status page</h5>
                  <ul>
                    <li>Pulls data from portal-metadata database to show script health</li>
                  </ul>
                </li>
                <li>
                  <h4>Bug Fixes</h4>
                  <ul>
                    <li>Refactored the full ClickUp collection script (the one that runs hourly and gets data from ClickUp) to remove old tasks that have been deleted in ClickUp without losing the history of those deleted tasks.</li>
                    <li>Increased memory allocation to collectAllClickupProjects.js to 2048mb to reduce failure rate</li>
                    <li>Analyzed expense data in new Expense tool</li>

                  </ul>
                </li>


              </ul>
            </li>




            <p class="footnote highlight yellow" *ngIf="role === 'dev' || role === 'god' || role === 'finance' || role === 'admin'">
              * This note <strong>and</strong> the components discussed not are only visible to Dev level users.
            </p>
          </ng-container>
        </ul>
      </div>



      <div class="notes major">
        <h3 class="date">Tuesday, May 6, 2025</h3>
        <ul>
          <li>Global Updates
            <ul>
              <li>Added this new Release Notes modal, accessible by appending <a href="#release-notes">#release-notes</a> (or <a href="#new">#new</a>) to the URL or just clicking the new link in bottom right.</li>
              <li>Added <strong>Code Version</strong> in the footer indicating when the site (not the data) was last updated.</li>
              <li>Added a dynamic <strong>as-of date</strong> under the page title indicating the most recent ClickUp data collection. When the system is working properly, the timestamp should always be the previous 5 minute mark.</li>
            </ul>
            <ul>
              <li><span class="to-do">To do:</span> Add the same timestamps to Burn and other pages still under development</li>
            </ul>
          </li>
          <li>XLS/CSV Export improvements
            <ul>
              <li>Added <strong>Space, Folder, and List name</strong> columns to exports</li>
              <li><span class="to-do">To do:</span> PDF export still needs styling</li>
            </ul>
          </li>
          <li>
            <h4>Feedback Tool</h4>
            <ul>
              <li>Added the <strong>Cannonball Feedback Tool</strong> for users report issues and make small feature/layout requests</li>
              <li>Added Google Login/Registration to <a href="https://feedback.cnbl.io/login">feedback.cnbl.io/login</a> for new and existing users with an &#64;cannonballcreative.agency account</li>
              <li>The tool is hidden by default, but will persist if you change it using the checkbox in the bottom left</li>
            </ul>
          </li>
        </ul>
      </div>

      <!-- END OF NOTES-->
      <div class="notes major">
        <h3 class="date">Sunday, May 4, 2025</h3>
        <ul>
          <li>
            <h4>Global Updates</h4>
            <ul>
              <li><strong>Added buttons to export data</strong> from tables as it is filtered on the screen</li>
              <li><strong>XLS or PDF download</strong> exports all <strong>visible</strong>, depending on your filter settings</li>
              <li><strong>CSV</strong> does not allow for multiple spreadsheets/pages/tabs, so each table has its own download button</li>
            </ul>
          </li>
          <li>
            <h4>Burn Page</h4>
            <ul>
              <li><strong>Changed Purchase Orders table to be horizontal</strong> over Projects instead of a sidebar</li>
              <li>Changed <strong>backend calculations</strong> for summary table</li>
              <li><strong>Redesigned page</strong> to allow for re-sizable table containers</li>
            </ul>

          </li>

          <li>
            <h4>Projects Page</h4>
            <ul>
              <li>Added new dropdowns to filter by Buyer and/or PO
              </li>
              <li> Added <strong>Archived</strong> and <strong>The Forge</strong> indicators to Projects accordion
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <!-- END OF NOTES-->

    </div>
  </div>
</div>